<script setup lang="ts">
import VText from '~/components/ui/VText.vue'

import { useGetMediaUrl } from '~/composables/useGetMediaUrl'

import type { Color } from '~/types/color'
import type { ThirdPartySource } from '~/types/track'

type Props = {
  trackSource: ThirdPartySource
}

const { trackSource } = defineProps<Props>()

const { getMediaUrl } = useGetMediaUrl()

const brandColor = computed(() => {
  return `brands-${trackSource}` as Extract<Color, `brands-${ThirdPartySource}`>
})
</script>

<template>
  <div
    :class="`md:tw-max-w-full tw-bg-brands-${trackSource} tw-mt-2 tw-flex tw-w-max tw-gap-2 tw-rounded tw-bg-opacity-5 tw-p-1`"
  >
    <!-- FYI SoundCloud logo: using img for now because SoundCloud asked us to use their new 
      logo and fontawesome uses old logo atm (7 bars in new logo, 12 in old logo)  -->
    <img
      v-if="trackSource === 'soundcloud'"
      loading="lazy"
      :class="`tw-bg-brands-${trackSource} tw-h-4 tw-w-4 tw-rounded tw-p-[2px]`"
      :src="getMediaUrl('soundcloud-logo-cloud-white.svg')"
      :alt="`${trackSource} logo`"
    />
    <i
      v-else
      :class="`fa-brands fa-${trackSource} tw-bg-brands-${trackSource} tw-h-4 tw-w-4 tw-rounded tw-p-[2px] tw-text-xs tw-text-white`"
    ></i>
    <VText
      cfg="sans/13/medium"
      :color="brandColor"
      class="ellipsis tw-inline-block tw-leading-4"
    >
      {{ $t('track.create.addedVia') }} {{ $t(`common.${trackSource}`) }}
    </VText>
  </div>
</template>
